import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, imgUrl, money } from "@/lib/api";
import { FadeUp, Eyebrow } from "@/components/Motion";
import PageHero from "@/components/PageHero";

const CATEGORIES = ["All", "Original Artwork", "Fine Art Prints", "Books", "Educational Products", "Merchandise"];

export default function Shop() {
  const [products, setProducts] = useState([]);
  const [category, setCategory] = useState("All");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const params = category === "All" ? {} : { category };
    api.get("/products", { params }).then((r) => setProducts(r.data)).finally(() => setLoading(false));
  }, [category]);

  return (
    <div data-testid="shop-page">
      <PageHero
        eyebrow="Gallery Shop"
        title="Original works, prints, books & objects of wonder."
        image=""
        height="60vh"
      />

      <section className="max-w-[1500px] mx-auto px-6 md:px-10 py-16 md:py-20">
        <div className="flex flex-wrap gap-x-8 gap-y-3 border-b border-matte/10 pb-6 mb-14">
          {CATEGORIES.map((c) => (
            <button
              key={c}
              onClick={() => setCategory(c)}
              data-testid={`category-${c.toLowerCase().replace(/\s+/g, "-")}`}
              className={`text-[11px] uppercase tracking-wide-sm transition-colors duration-300 ${
                category === c ? "text-matte border-b border-plum pb-1" : "text-matte/40 hover:text-matte"
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        {loading ? (
          <p className="text-matte/40 font-serif text-2xl">Loading the collection…</p>
        ) : products.length === 0 ? (
          <p className="text-matte/40 font-serif text-2xl" data-testid="shop-empty">No works in this category yet.</p>
        ) : (
          <div className="grid grid-cols-2 lg:grid-cols-3 gap-x-6 md:gap-x-10 gap-y-16">
            {products.map((p, i) => (
              <FadeUp key={p.id} delay={(i % 3) * 0.08}>
                <Link to={`/shop/${p.id}`} className="group block" data-testid={`product-card-${p.id}`}>
                  <div className="overflow-hidden bg-cream aspect-[4/5]">
                    <img
                      src={imgUrl(p.images?.[0])}
                      alt={p.title}
                      className="w-full h-full object-cover group-hover:scale-[1.04] transition-transform duration-[1200ms] ease-out"
                    />
                  </div>
                  <div className="pt-5 flex items-start justify-between gap-3">
                    <div>
                      <p className="text-[10px] uppercase tracking-wide-sm text-plum mb-1">{p.category}</p>
                      <h3 className="font-serif text-xl md:text-2xl leading-tight">{p.title}</h3>
                    </div>
                    <span className="font-serif text-lg md:text-xl whitespace-nowrap">{money(p.price)}</span>
                  </div>
                </Link>
              </FadeUp>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
